import React from 'react'
import Forms from "./forms/Forms";
import LatestFreeQuestions from "./LatestFreeQuestions";
import LatestAnswers from "./LatestAnswers";

function ZadajBezplatnePytanie({if_WK, default_category, uuid}) {
    return (
    <>
        <Forms if_WK={if_WK} default_category={default_category} uuid={uuid}/>
        <LatestFreeQuestions />
        <LatestAnswers />
    </>
    )
}

export default ZadajBezplatnePytanie